import { addressRoute, newAddressRoute } from "./address";
import { addressPaymentRoute } from "./address-payment";

export const allAddressPaymentRoute = [
  addressRoute(),
  newAddressRoute(),
  addressPaymentRoute()
];
